import { createFileRoute } from '@tanstack/react-router';
import { RunsPage, validateRunsSearch } from '@/features/settings/AgentsPages';

export const Route = createFileRoute('/app/settings/agents/runs/')({
  validateSearch: validateRunsSearch,
  component: function RunsRoute() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return <RunsPage search={search} onSearch={(s) => void navigate({ search: s, replace: true })} />;
  },
  staticData: { title: 'Agent runs · Settings' },
});
